export const ADD_SUCCESS_MESSAGE = "ADD_SUCCESS_MESSAGE";
export const REMOVE_SUCCESS_MESSAGE = "REMOVE_SUCCESS_MESSAGE";

export function addSuccessMessage(data) {
	return {
		type: ADD_SUCCESS_MESSAGE,
		data,
	};
}

export function removeSuccessMessage() {
	return {
		type: REMOVE_SUCCESS_MESSAGE,
	};
}
